<script lang="ts">
	import clickOutside from '$lib/actions/clickOutside';
	import Checkmark from '$lib/icons/checkmark.svelte';
	import ChevronDown from '$lib/icons/chevronDown.svelte';
	import type { SortType } from '$lib/types/yotpo';
	import { fade } from 'svelte/transition';

	interface Props {
		onselect: (type: SortType) => void;
	}

	let { onselect }: Props = $props();

	type SelectItem = {
		label: string;
		value: SortType;
	};

	const sortByItems: SelectItem[] = [
		{ label: 'Newest to oldest', value: 'createdAtDesc' },
		{ label: 'Oldest to newest', value: 'createdAtAsc' },
		{ label: 'Highest rating', value: 'ratingHighest' }
	];

	let selectedSortBy = $state<SelectItem>(sortByItems[0]);
	let dropDownOpen = $state(false);

	function toggleOpen() {
		dropDownOpen = !dropDownOpen;
	}

	function selectSort(selectedSort: SelectItem) {
		dropDownOpen = false;
		selectedSortBy = selectedSort;
		onselect(selectedSortBy.value);
	}
</script>

<div class="relative text-brown-1" use:clickOutside={() => (dropDownOpen = false)}>
	<button onclick={toggleOpen}
		>Sort by
		<span class="ml-0.5 font-semibold">
			{selectedSortBy.label}
		</span>
		<ChevronDown class="inline-block h-4 w-4" /></button
	>

	{#if dropDownOpen}
		<div
			class="absolute mt-2 flex w-full flex-col gap-y-1 rounded-lg border border-brown-6 bg-white px-2 py-4 shadow-[0_0_12px_0_rgba(0,0,0,0.08)]"
			transition:fade={{ duration: 120 }}
		>
			{#each sortByItems as sortByItem}
				<button
					onclick={() => selectSort(sortByItem)}
					class="flex items-center justify-between rounded-lg px-2 py-1 text-left hover:bg-brown-6"
				>
					<p>
						{sortByItem.label}
					</p>
					{#if sortByItem.value === selectedSortBy.value}
						<Checkmark class="h-4 w-4 text-brown-4" />
					{/if}
				</button>
			{/each}
		</div>
	{/if}
</div>
